import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于内容来源、热榜规则与投稿方式，这里一次说清楚。"
          align="center"
        />
        <div className="mt-10 divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
          {faqs.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left cursor-pointer"
                >
                  <span className="font-heading text-sm font-bold leading-6 text-foreground-950 md:text-base">
                    {f.q}
                  </span>
                  <i
                    className={`shrink-0 text-xl text-primary-500 transition-transform ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}